/* eslint-disable no-await-in-loop */
import { uniqueId } from "lodash"
import { Action } from "../models/action"
import { Dialog, DialogType } from "../models/dialog"
import { Subscription } from "../models/subscription"
import ActionService from "./action"
import DynamicParamsService from "./dynamicParams"
import { Service } from "./Service"

class DialogService extends Service {
    private static instance: DialogService

    private subscribers: Array<Subscription> = []

    constructor() {
        super()
        // set le nom du service
        this.name = "DialogService"
        // ajoute toute les methodes du service au tableau de mapping
        this.serviceMap = [{ key: "send", fct: this.send }]
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): DialogService {
        if (!this.instance) {
            this.instance = new DialogService()
        }
        return this.instance
    }

    /**
     * Abonnement aux event d'un composant
     * @param to nom du composant à qui on s'abonne
     * @param type type d'action à laquelle on s'abonne
     * @param from nom de la sub / de celui qui c'est abonné
     * @param actions callback à executer lorsque l'event est trigger
     * @returns Nom de la sub / de celui qui c'est abonné
     */
    public subscribe(
        to: string,
        type: DialogType,
        from: string,
        actions: ((...params: Array<any>) => void) | Action[]
    ): string {
        const subId = uniqueId()
        this.subscribers.push({
            id: subId,
            to,
            type,
            from,
            actions,
        })
        return subId
    }

    /**
     * Abonnement aux event d'un composant
     * @param subscriptionId name of the subscription
     */
    public unsubscribe(subscriptionId: string): void {
        if (subscriptionId) {
            this.subscribers = this.subscribers.filter((sub: Subscription) => {
                return sub.id !== subscriptionId
            })
        }
    }

    /**
     * Lance un event
     * @param dialog message à envoyer aux abonnés
     */
    public async send(dialog: Dialog): Promise<void> {
        // on cherche si il y a des abonnés qui sont interessé par le sender
        for (let index = 0; index < this.subscribers.length; index += 1) {
            const sub: Subscription = this.subscribers[index]
            // si on trouve un abonné OU aboné à tout le monde
            // ou si le dialogue cible un element en particulier avec le param "to"

            if (
                sub.type === dialog.type &&
                ((sub.to === "all" && dialog.to && sub.from === dialog.to) ||
                    (!dialog.to &&
                        (sub.to === dialog.sender || sub.to === "all")) ||
                    (sub.to === dialog.sender &&
                        (dialog.to === sub.from || !dialog.to)) ||
                    (sub.from === dialog.to && sub.to === "all"))
            ) {
                let resolvedParams: Array<unknown> = []
                // si il y a des paramètres à récupèrer on les cherchent dans le Store
                if (dialog.params && dialog.params.length) {
                    resolvedParams = await DynamicParamsService.resolve(
                        dialog.params
                    )
                }

                // on a les paramètres qui sont résolues donc on va
                // verifier si c'est des actions ou bien une fct à exec
                if (typeof sub.actions === "function") {
                    sub.actions(...resolvedParams)
                } else if (sub.actions && Array.isArray(sub.actions)) {
                    await ActionService.exec(sub.actions)
                }
            }
        }
    }
}

export default DialogService
